import {BreadCrumb} from "pages/common/BreadCrumb"
import {TitleInDetailPage} from "pages/common/TitleInDetailPage"
import {PageTabInDetailPage, PageTabItemInDetailPage} from "pages/common/PageTabInDetailPage"
import {Outlet, useNavigate, useParams} from "react-router-dom"
import {useFindGroupById} from "hooks/query/group-query"
import {UpdateGroupForm} from "pages/group/UpdateGroupForm"
import {UpdateGroupAttribute} from "pages/group/UpdateGroupAttribute"
import {UpdateGroupRoleMapping} from "pages/group/UpdateGroupRoleMapping"
import {UpdateGroupMembers} from "pages/group/UpdateGroupMembers"

export function UpdateGroupView() {
    const {id, view} = useParams<{id: string, view: string}>()
    const navigate = useNavigate()
    const {data: group} = useFindGroupById(id)
    if(!group) return <div>Loading...</div>
    return (
        <div className="main-body">
            <BreadCrumb title="Group" subTitle={`/ ${group?.name}`}/>
            <div className="sub-panel">
                <TitleInDetailPage title={group?.name || ""} iconPath="/img/icon-role.png"/>
                <div className="sub-content-box">
                    <PageTabInDetailPage>
                        <PageTabItemInDetailPage title="그룹 정보" active={view === "form"} iconClass="fa-rectangle-list"
                                                 onClick={() => navigate(`/group/update/${id}/form`)}/>
                        <PageTabItemInDetailPage title="Attributes" active={view === "attribute"} iconClass="fa-list-check"
                                                 onClick={() => navigate(`/group/update/${id}/attribute`)}/>
                        <PageTabItemInDetailPage title="Rol Mapping" active={view === "role-mapping"} iconClass="fa-link"
                                                 onClick={() => navigate(`/group/update/${id}/role-mapping`)}/>
                        <PageTabItemInDetailPage title="Member" active={view === "member"} iconClass="fa-user-check"
                                                 onClick={() => navigate(`/group/update/${id}/member`)}/>
                    </PageTabInDetailPage>
                    {view === "form" && (<UpdateGroupForm/>)}
                    {view === "attribute" && (<UpdateGroupAttribute/>)}
                    {view === "role-mapping" && (<UpdateGroupRoleMapping/>)}
                    {view === "member" && (<UpdateGroupMembers/>)}
                    <Outlet/>
                </div>
            </div>
        </div>
    )
}